/* eslint-disable react/require-default-props */
import React from 'react';
import companyId from 'services/company_id';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { Container } from './styles';

interface CardAgendaProps {
  date: string;
  title: string;
  description: string;
  color: string;
  type: string;
  biddingId: number;
  eventCompanyId?: number;
  company?: string;
}

const CardAgenda = (props: CardAgendaProps) => {
  const { date, title, description, color, type, biddingId, eventCompanyId, company } = props;

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const managementUrl = `/minhas_licitacoes/management/${biddingId}/${
    eventCompanyId ?? companyId(profile)
  }`;

  const handleCardClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    window.open(managementUrl, 'management');
  };

  return (
    <Container color={color} type={type}>
      <a href={managementUrl} onClick={handleCardClick}>
        <div className="card mt-2">
          <div className="time">{date}</div>
          <div className="content">
            {company && <div className="company">{company}</div>}
            <div className="date">{title}</div>
            <div className="description">{description}</div>
          </div>
        </div>
      </a>
    </Container>
  );
};

export default CardAgenda;
